import { ReactNode } from "react";
import { Theme } from "../../../theme";
import AppTitle from "./AppTitle";

interface CardProps {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, actions, children, className }: CardProps) {
  return (
    <div
      className={`select-none pb-4 bg-white dark:bg-gray-800 ${Theme.greyBorder} ${className}`}
    >
      <div className="flex justify-between flex-wrap items-center mx-auto px-6 pt-4 pb-3 border-b border-gray-100 dark:border-gray-700">
        <AppTitle level={3} text={title} />
        <div className="flex gap-2">{actions}</div>
      </div>
      <div className="pt-6 px-2 md:px-4">{children}</div>
    </div>
  );
}
